import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import React from 'react';
import { TFunction } from 'react-i18next';
import { DiscountCodesTableRow } from './rows';
import { CurrencyObject } from 'common/types';
import { Typography } from '@mui/material';
import { getPricingString } from 'common/utils/common';

interface DiscountCodesTableColDef extends GridColDef {
	field: keyof DiscountCodesTableRow;
	renderCell?: (params: GridRenderCellParams<any, DiscountCodesTableRow>) => React.ReactNode;
}

export const getDiscountCodesTableColumns = (deps: { t: TFunction; currency: CurrencyObject }) => {
	const { t, currency } = deps;

	const columns: DiscountCodesTableColDef[] = [
		{
			field: 'code',
			headerName: t('discount.discountCode', 'Discount code'),
			minWidth: 400,
			renderCell: ({ value }) => (
				<Typography sx={{ fontWeight: 500, fontSize: '1.4rem' }}>{value}</Typography>
			),
		},
		{
			field: 'discountPercentage',
			headerName: t('DiscountCodesTable.discountPercent', 'Discount (%)'),
			minWidth: 200,
			valueFormatter: ({ value }) => value || '-',
			align: 'center',
			headerAlign: 'center',
		},
		{
			field: 'discountAmount',
			headerName: t('DiscountCodesTable.discountCurrency', {
				currencySymbol: currency.displayAs,
				defaultValue: 'Discount ({{currencySymbol}})',
			}),
			valueFormatter: ({ value }) => (!!value ? getPricingString(value) : '-'),
			minWidth: 200,
			align: 'center',
			headerAlign: 'center',
		},
		{
			field: 'validFor',
			headerName: t('DiscountCodesTable.validFor', 'Valid for'),
			minWidth: 300,
			flex: 1,
		},
		{
			field: 'usageCount',
			headerName: t('DiscountCodesTable.timesUsed', 'Times used'),
			align: 'center',
			headerAlign: 'center',
			minWidth: 200,
		},
	];

	return columns;
};
